/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StampingData } from '../../models/stamping-data';

export interface DocumentStampDocument$Params {

/**
 * GUID of the document
 */
  documentId: string;

/**
 * GUID of the stamp
 */
  stampId: string;
  
    /**
     * Stamping data
     */
    body?: StampingData
}

export function documentStampDocument(http: HttpClient, rootUrl: string, params: DocumentStampDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, documentStampDocument.PATH, 'post');
  if (params) {
    rb.path('documentId', params.documentId, {});
    rb.path('stampId', params.stampId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

documentStampDocument.PATH = '/document/{documentId}/stamp/{stampId}';
